var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bto-sb-element"},[(!_vm.disableVideoStream)?_c('livestream-component',{key:_vm.streamId,attrs:{"streamId":_vm.streamId,"isOnlyVideo":true,"providerId":_vm.providerId}}):_vm._e(),_c('horse-racing-widget'),_c('schedule-races-widget-hr')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }